import { z } from "zod";

export const cookiesConsentFormSchema = z.object({
  necessaryCookies: z.boolean().default(true),
  preferencesCookies: z.boolean().default(true),
  statisticsCookies: z.boolean().default(true),
  marketingCookies: z.boolean().default(true),
});

export type TCookiesConsentFormSchema = z.infer<
  typeof cookiesConsentFormSchema
>;
